import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ChangeSortButton } from "./ChangeSortButton";
import { FacilityReportsListControls } from "./Controls";
import { useFacilityReports } from "./hooks";
import Pagination from "../../Pagination";
import "./styles.scss";

export const FacilityReportsList: React.FC = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportsList.${key}`);

  const {
    query,
    filterFormData,
    handleChangeFilterFormData,
    searchParams,
    setSearchParams,
    totalCount,
  } = useFacilityReports();

  const facilityReports = query.data?.data;

  const handleViewReport = (facilityReportId: number) => {
    console.log(facilityReportId);
  };

  const handleDeleteReport = (facilityReportId: number) => {
    console.log(facilityReportId);
  };

  return (
    <div className="white-border-panel facility-reports-list">
      <h2 className="facility-reports-list-title">{t("reports")}</h2>
      <FacilityReportsListControls
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
      <table className="facility-reports-list-content">
        <thead>
          <tr>
            <th className="facility-name">
              <ChangeSortButton
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                fieldName="location.name"
                translationKey="facility_name"
              />
            </th>
            <th className="created-at">
              <ChangeSortButton
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                fieldName="created_at"
                translationKey="created_at"
              />
            </th>
            <th className="start-date">
              <ChangeSortButton
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                fieldName="start_date"
                translationKey="start_date"
              />
            </th>
            <th className="end-date">
              <ChangeSortButton
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                fieldName="end_date"
                translationKey="end_date"
              />
            </th>
            <th className="status">
              <ChangeSortButton
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                fieldName="status"
                translationKey="status"
              />
            </th>
            <th className="actions"></th>
          </tr>
        </thead>
        <tbody>
          {facilityReports &&
            facilityReports.map((facilityReport) => (
              <tr key={facilityReport.id}>
                <td className="facility-name">
                  {facilityReport.location.name}
                </td>
                <td className="created-at">
                  {dayjs(facilityReport.created_at).format("YYYY/MM/DD")}
                </td>
                <td className="start-date">
                  {dayjs(facilityReport.start_date).format("YYYY/MM/DD")}
                </td>
                <td className="end-date">
                  {dayjs(facilityReport.end_date).format("YYYY/MM/DD")}
                </td>
                <td className={`status ${facilityReport.status}`}>
                  {t(`status.${facilityReport.status}`)}
                </td>
                <td className="actions">
                  <div className="actions-container">
                    <button
                      className="btn btn-border"
                      onClick={() => handleViewReport(facilityReport.id)}
                      type="button"
                    >
                      {t("view")}
                    </button>
                    <button
                      className="btn btn-border btn-border-red"
                      onClick={() => handleDeleteReport(facilityReport.id)}
                      type="button"
                    >
                      {t("delete")}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Pagination
        filterFormData={filterFormData}
        totalRowsNumber={totalCount}
        onChangeFilterFormData={handleChangeFilterFormData}
      />
    </div>
  );
};
